import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { useSelector } from "react-redux";
import "./layout.css";

import { store } from "./store";
import { StyledSidebarMenu } from "./StyledSidebarMenu";
import { buildMenu } from "./MenuSetting";
import { RootState } from "../../redux/store";

export { menuItems, menuItemsDefaultSetting } from "./MenuSetting";

export default function SidebarContent() {
    const { t } = useTranslation();
    const { collapsed, isDefault } = useSnapshot(store);
    const foodCourt = useSelector(
        (state: RootState) => state.global.isFoodCourt
    );

    const items = useMemo(() => buildMenu(t, foodCourt, isDefault), [
        t,
        foodCourt,
        isDefault,
    ]);

    return (
        <StyledSidebarMenu
            name={collapsed ? "" : "MENU"}
            collapsed={collapsed}
            menuItems={items}
        />
    );
}
